import { useEffect, useState } from 'react';


/** localStorage key for persisting timezone preference */
export const LS_KEY = 'useLocalZone';

const readPreference = (): boolean => {
  try { return localStorage.getItem( LS_KEY ) !== 'false'; }
  catch { return true; }
};

/**
 * Manages the user's "show times in local zone vs UTC" preference, persisted
 * to localStorage. The stored value is read synchronously in the useState
 * initializer so consumers see the real preference on the first render —
 * forms that bake the value into defaultValues no longer get a stale `true`.
 *
 * @returns A tuple containing:
 *   - boolean: Current timezone preference (true for local, false for UTC)
 *   - function: Setter function to update the timezone preference
 */
export function useLocalZonePreference(): [boolean, ( next: boolean ) => void] {
  const [ useLocalZone, setUseLocalZone ] = useState<boolean>( readPreference );

  useEffect( () => {
    try {
      localStorage.setItem( LS_KEY, JSON.stringify( useLocalZone ) );
    } catch { /* empty */ }
  }, [ useLocalZone ] );

  return [ useLocalZone, setUseLocalZone ];
}
